import React, { Fragment, PureComponent } from 'react';

import bytes from 'bytes';
import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import { RelativeDate } from '@atlassian/bitkit-date';

import DetailsCard, { Row, Field } from 'src/components/details-card';

import SrcDirMetadataFetcher from '../containers/srd-dir-metadata-fetcher';
import { File, FileMeta } from '../types';
import getLanguages from '../utils/get-languages';

import messages from './file-details-card.i18n';

export type FileDetailsCardProps = {
  file?: File;
  intl: InjectedIntl;
  isCollapsed: boolean;
  meta?: FileMeta;
  path?: string;
  isLoading: boolean;
  lastUpdated: Date | null | undefined;
};

class FileDetailsCard extends PureComponent<FileDetailsCardProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    isCollapsed: false,
  };

  renderContent() {
    const { file, meta, isLoading, lastUpdated } = this.props;

    if (!meta || isLoading) {
      return null;
    }

    // bytes lib types need to be updated to fix this
    const formattedSize =
      // @ts-ignore
      meta && meta.size ? bytes(meta.size, { unitSeparator: ' ' }) : null;

    let fileType = '';
    if (meta.path) {
      const parts = meta.path.split('/');
      const lang = parts.pop();
      if (lang) {
        [fileType] = getLanguages(lang);
      }
    }

    return (
      <Fragment>
        {lastUpdated && (
          <Row>
            <Field
              label={<FormattedMessage {...messages.lastUpdatedLabel} />}
              value={<RelativeDate date={lastUpdated} />}
            />
          </Row>
        )}

        {fileType && (
          <Row>
            <Field
              label={<FormattedMessage {...messages.typeLabel} />}
              value={fileType}
            />
          </Row>
        )}

        <Row>
          {file && (
            <Field
              label={<FormattedMessage {...messages.lineCountLabel} />}
              value={file.contents.split('\n').length}
            />
          )}
          {formattedSize && (
            <Field
              label={<FormattedMessage {...messages.sizeLabel} />}
              value={formattedSize}
            />
          )}
        </Row>
      </Fragment>
    );
  }

  render() {
    const { intl, isCollapsed, isLoading, meta, path } = this.props;
    const label = intl.formatMessage(messages.cardLabel);

    const parentPath = path ? path.split('/').slice(0, -1).join('/') : null;

    return (
      <DetailsCard
        isLoading={!meta || isLoading}
        label={label}
        isCollapsed={isCollapsed}
      >
        <SrcDirMetadataFetcher path={parentPath || '/'} />
        {this.renderContent()}
      </DetailsCard>
    );
  }
}

export default injectIntl(FileDetailsCard);
